module.exports = __webpack_public_path__ + "static/img/blast.89a8ce3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/purifiers/blast.jpg
// module id = dnrP
// module chunks = 1